angular.module('natura').directive('pggPrint', [function () {
    return {
        restrict: "E",
        templateUrl: "assets/terkep/app/print/print.html",
        replace: true,
        scope: {
            map: "="
        },
        controller: "PggPrintController",
        controllerAs: "ctrl",
        bindToController: true
    };
}]);

angular.module('natura').provider(
    "pggPrintProvider", [function () {

        var config = {
            scope: null
        };

        this.$get = [
            '$http',
            'pggConfigProvider',
            'pggSearchProvider',

            function ($http, pggConfigProvider, pggSearchProvider) {

                var _getScope = function () {
                    return config.scope;
                };

                var _setScope = function (scope) {
                    config.scope = scope;
                };

                /**
                 * Lekérdezi a nyomtatási lehetőségek json-jét (dpi-k, elrendezések,
                 * felbontások, formátumok)
                 */
                var _getPrintPromise = function (request) {
                    var promise = $http({
                        url: pggConfigProvider.getPrintUrl(),
                        method: 'JSONP',
                        params: {
                            request: request,
                            callback: "JSON_CALLBACK"
                        },
                    }).then(function (response) {
                        return response;
                    });
                    return promise;
                };

                /**
                 * Végrehajtja a nyomtatást egy json objektum alapján
                 *
                 * @param template:
                 *          MapFish nyomtatáshoz felhasználható json objektum
                 */
                var _postPrintPromise = function (template) {
                    template.location = window.location.hostname;
                    var promise = $http({
                        method: "POST",
                        url: pggConfigProvider.getPrintUrl(),
                        data: template
                    }).then(function (response) {
                        return response;
                    });
                    return promise;
                };

                var _postPrintTerkepPromise = function (template) {
                    template.location = window.location.hostname;
                    var promise = $http({
                        method: "POST",
                        url: pggConfigProvider.getPrintUrl(),
                        headers: {
                            accept: 'application/pdf, image/png, image/jpeg, image/jpg, image/tiff'
                        },
                        data: template,
                        responseType: 'arraybuffer',
                        cache: false,
                        transformResponse: function (data, headers) {
                            var file = null;
                            if (data) {
                                file = new Blob([data], {
                                    type: headers('content-type')
                                });
                            }
                            var fileName = 'natura-terkep.' + headers('content-type').split("/")[1];
                            var result = {
                                blob: file,
                                fileName: fileName
                            };
                            return {
                                response: result
                            };
                        }
                    }).then(function (response) {
                        return response;
                    });
                    return promise;
                };

                var _postPrintJelmagyarazatPromise = function (template) {
                    var promise = $http({
                        method: "GET",
                        url: "/assets/terkep/etc/jelmagyarazat.pdf",
                        headers: {
                            accept: 'application/pdf'
                        },
                        responseType: 'arraybuffer',
                        cache: false,
                        transformResponse: function (data, headers) {
                            var file = null;
                            if (data) {
                                file = new Blob([data], {
                                    type: headers('content-type')
                                });
                            }
                            var fileName = 'natura-terkep-jelmagyarazat.pdf';
                            var result = {
                                blob: file,
                                fileName: fileName
                            };
                            return {
                                response: result
                            };
                        }
                    }).then(function (response) {
                        return response;
                    });
                    return promise;
                };

                var _getFileNameFromHeader = function (header) {
                    if (!header) return null;
                    var result = header.split(";")[1].trim().split("=")[1];
                    return result.replace(/"/g, '');
                };

                // http://blog.davidjs.com/2015/07/download-files-via-post-request-in-angularjs/
                var _postPrintTervPromise = function (tablak) {
                    var postData = {
                        ids: tablak
                    };
                    var promise = $http({
                        method: "POST",
                        url: pggConfigProvider.getBaseUrl() + "/szabalyok/felhasznalo",
                        data: postData,
                        headers: {
                            accept: 'application/pdf'
                        },
                        responseType: 'arraybuffer',
                        cache: false,
                        transformResponse: function (data, headers) {
                            var pdf = null;
                            if (data) {
                                pdf = new Blob([data], {
                                    type: 'application/pdf'
                                });
                            }
                            var fileName = _getFileNameFromHeader(headers('content-disposition'));
                            var result = {
                                blob: pdf,
                                fileName: fileName
                            };
                            return {
                                response: result
                            };
                        }
                    }).then(function (response) {
                        return response;
                    });
                    return promise;
                };

                /**
                 * Visszaadja azokat a geometriákat, amik az aktuális nézetbe esnek
                 *
                 * @param map:
                 *          térkép objektum
                 * @param layer:
                 *          vektor réteg
                 *
                 * TODO: egyelőre csak azokat az elemeket küldi el amik az aktuális
                 * nézetben vannak de ez problémás lehet, ha túl pici a térképi
                 * nézet, de A4-esre akarja nyomtatni mert akkor lemarad egy csomó
                 * elem és csak azt rakja be, amit tényleg lát. (Esetleg Heron-ból
                 * meg lehetne nézni hogy ott hogy oldották meg.)
                 */
                var _getFeaturesByExtent = function (map, layer) {
                    var source = layer.getSource();
                    var extent = map.getView().calculateExtent(map.getSize());
                    return source.getFeaturesInExtent(extent);
                };

                /**
                 * GeoJSON-né formálja és a MapFish számára szükséges stílust
                 * hozzárendeli egy adott vektor feature tömbhöz.
                 *
                 * @param features:
                 *          ol.Feature tömb
                 */
                var _getGeoJSON = function (features) {
                    var format = new ol.format.GeoJSON();
                    var geojsonString = format.writeFeatures(features);
                    var geojsonObject = JSON.parse(geojsonString);
                    for (var i = 0; i < geojsonObject.features.length; i++) {
                        var feature = geojsonObject.features[i];
                        // új elemnél nincs properties attribútum, így azt hozzá kell
                        // adni a stílus miatt
                        if (feature.properties === null) {
                            feature.properties = {};
                        }
                        feature.properties._gx_style = i + 1;
                    }
                    return geojsonObject;
                };

                /**
                 * rgba string-et kovertál és visszaad egy objektumot a hex és az
                 * opacity értékkel
                 *
                 * @param rgbaString:
                 *          pl. "rgba(0, 0, 255, 0.15)"
                 */
                var _rgbaToHexAndOpacity = function (rgbaString) {
                    var rgb = rgbaString.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
                    var hex = (rgb && rgb.length === 4) ? "#" + ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                        ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
                        ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
                    var opacity = rgbaString.split(",")[3].split(")")[0].trim();
                    return {
                        color: hex,
                        opacity: opacity
                    };
                };

                /**
                 * Egy adott vektor rétegből kiolvassa a MapFish nyomtatáshoz
                 * szükséges stílus-értékeket
                 *
                 * @param layer:
                 *          ol.layer.Vector réteg
                 */
                var _getStyle = function (layer) {
                    var style = layer.getStyle();
                    console.log(style);
                    var fillStyle = style.getFill();
                    var strokeStyle = style.getStroke();
                    var fillObj = _rgbaToHexAndOpacity(fillStyle.getColor());
                    var strokeObj = _rgbaToHexAndOpacity(strokeStyle.getColor());
                    return {
                        fillColor: fillObj.color,
                        fillOpacity: fillObj.opacity,
                        strokeColor: strokeObj.color,
                        strokeOpacity: strokeObj.opacity,
                        strokeWidth: strokeStyle.getWidth()
                    };
                };

                var _getStyles = function (geojson) {
                    var styles = {};
                    var defaultColor = "#337AB7";
                    var textColor = "#000000";
                    for (var i = 0; i < geojson.features.length; i++) {
                        styles[i + 1] = {
                            fillColor: defaultColor,
                            fillOpacity: 0.2,
                            strokeColor: defaultColor,
                            strokeOpacity: 1,
                            strokeWidth: 2,
                            label: geojson.features[i].properties.name,
                            fontWeight: "normal",
                            fontSize: "14px",
                            fontFamily: "Verdana",
                            fontColor: textColor
                        };
                    }
                    return styles;
                };

                /**
                 * Összeállítja a MapFish nyomtatáshoz szükséges rétegeket, a
                 * szükséges paraméterekkel
                 *
                 * @param map:
                 *          ol.Map térkép objektum
                 */
                var _getMapLayersForPrint = function (map) {
                    var _layers = [];
                    var _overviewLayers = [];
                    // mindig a geox alaptérképe legyen az áttekintő térkép
                    _overviewLayers.push({
                        customParams: {
                            TRANSPARENT: true
                        },
                        layers: ["natura:ekozmu_basemap"],
                        opacity: 1,
                        baseURL: pggConfigProvider.getGeoserverUrl(),
                        styles: [""],
                        singleTile: false,
                        format: "image/png",
                        type: "WMS"
                    });
                    map.getLayers().forEach(
                        function (layer) {
                            // csak ha a térkép látható
                            if (layer.getVisible()) {
                                var name = layer.get("name");
                                var opacity = layer.get("opacity");
                                var source = layer.getSource();
                                var attrs;
                                if (layer instanceof ol.layer.Tile) {
                                    // csak wms rétegekre
                                    if (source instanceof ol.source.TileWMS) {
                                        var url = source.getUrls()[0];
                                        var params = source.getParams();
                                        attrs = {
                                            customParams: {
                                                TRANSPARENT: true
                                            },
                                            layers: [params.LAYERS],
                                            opacity: opacity,
                                            baseURL: url,
                                            styles: [""],
                                            singleTile: !params.TILED,
                                            format: "image/png",
                                            type: "WMS"
                                        };
                                        // ha van cql_filter, vegye azt is figyelembe
                                        if (params.hasOwnProperty("CQL_FILTER")) {
                                            attrs.customParams.CQL_FILTER = params.CQL_FILTER;
                                        }
                                        _layers.push(attrs);
                                    }
                                } else if (layer instanceof ol.layer.Vector) {
                                    var features = _getFeaturesByExtent(map, layer);
                                    var geoJSON = _getGeoJSON(features);
                                    // var style = _getStyle(layer);
                                    attrs = {
                                        styleProperty: "_gx_style",
                                        styles: _getStyles(geoJSON),
                                        type: "Vector",
                                        opacity: opacity,
                                        geoJson: geoJSON
                                    };
                                    _layers.push(attrs);
                                }
                            }
                        });
                    return {
                        layers: _layers,
                        overviewLayers: _overviewLayers
                    };
                };

                /**
                 * Visszaad egy MapFish nyomtatáshoz felhasználható template-t
                 */
                var _getTemplate = function () {
                    return {
                        overviewLayers: [],
                        mapScale: 10000,
                        outputFormat: "pdf",
                        mapComment: "Teszt nyomtatás",
                        layers: [],
                        pages: [],
                        srs: "EPSG:23700",
                        units: "m",
                        mapFooter: "",
                        layout: "A4 fekvő",
                        dpi: 100,
                        mapTitle: "Natura 2000",
                        projektLogoUrl: pggConfigProvider.getProxyUrl() + "/img/projektlogo.jpg",
                        svajciLogoUrl: pggConfigProvider.getProxyUrl() + "/img/svajci.jpg"
                    };
                };

                /**
                 * Kiokosítja a template json objektumot a felhasználó által
                 * kiválaszottt paraméterekkel (térkép címe, formátum stb)
                 *
                 * @param map:
                 *          ol.Map objektum
                 * @param params:
                 *          json objektum, benne a szükséges beállításokkal (pl.
                 *          térkép címe, lépték stb).
                 */
                var _createPostTemplate = function (map, params) {
                    var layersObj = _getMapLayersForPrint(map);
                    var template = _getTemplate();
                    var zoom = map.getView().getZoom();
                    var projection = map.getView().getProjection();
                    // template módosítása
                    template.overviewLayers = layersObj.overviewLayers;
                    template.layers = layersObj.layers;
                    template.mapTitle = params.title;
                    template.mapComment = params.comment;
                    template.outputFormat = params.options.outputFormats.selected.name;
                    template.dpi = params.options.dpis.selected.name;
                    template.layout = params.options.layouts.selected.name;
                    template.srs = projection.getCode();
                    template.units = projection.getUnits();
                    // a scales az 1:100-tól indul, de a zoom az a 4.000.000-tól, így
                    // meg kell fordítani a listát
                    template.mapScale = params.options.scales.selected.value;
                    template.pages.push({
                        center: map.getView().getCenter(),
                        scale: template.mapScale,
                        rotation: 0,
                        mapTitle: params.title,
                        mapComment: params.comment
                    });
                    return template;
                };

                /**
                 * Begyűjti a szükséges méretarányt, hogy ha az egérrel nagyít a
                 * felhasználó, akkor az frissítse be a legördülőben is az értéket
                 */
                var _getPrintScale = function (scope, scaleProvider) {
                    var resolution = scope.map.getView().getResolution();
                    var scale = scaleProvider.getScaleForResolution(resolution);
                    for (var i = 0; i < scope.printInfo.scales.length; i++) {
                        var s = scope.printInfo.scales[i];
                        if (s.value == scale + ".0") {
                            return s;
                        }
                    }
                };

                var _refreshTablak = function () {
                    if (_getScope().isGazdalkodoiModul) {
                        _getScope().tablak = [];
                        pggSearchProvider.getGazdalkodasiteruletPromise().then(function (data) {
                            if (data.status == 200 && data.statusText == "OK" && data.data.errors === null) {
                                if (data.data.hasOwnProperty("geojson") && data.data.geojson.hasOwnProperty("features")) {
                                    angular.forEach(data.data.geojson.features, function (tabla) {
                                        tabla.selected = false;
                                        _getScope().tablak.push(tabla);
                                    });
                                } else {
                                    $log.error("Hiba a gazdálkodási terület geometria lekérdezésnél");
                                    $log.error(data);
                                }
                            } else {
                                $log.error("Hiba a gazdálkodási terület lekérdezésnél");
                                $log.error(data);
                            }
                        });
                    }
                };

                /**
                 * RETURNS
                 */
                return {
                    getScope: _getScope,
                    setScope: _setScope,
                    getPrintPromise: _getPrintPromise,
                    postPrintTerkepPromise: _postPrintTerkepPromise,
                    postPrintTervPromise: _postPrintTervPromise,
                    postPrintJelmagyarazatPromise: _postPrintJelmagyarazatPromise,
                    postPrintPromise: _postPrintPromise,
                    createPostTemplate: _createPostTemplate,
                    getPrintScale: _getPrintScale,
                    refreshTablak: _refreshTablak
                };
            }
        ];
    }]);

angular.module('natura').controller(
    'PggPrintController', [
        '$scope',
        '$http',
        '$sce',
        '$log',
        'pggConfigProvider',
        'pggPrintProvider',
        'pggScaleProvider',
        'pggEditProvider',
        'pggSearchProvider',
        '$window',
        'FileSaver',
        function ($scope, $http, $sce, $log, pggConfigProvider, pggPrintProvider, pggScaleProvider, pggEditProvider, pggSearchProvider, $window, FileSaver) {
            $scope.map = this.map;
            $scope.printInProgress = false;
            $scope.printInfo = {};
            $scope.params = {
                title: "",
                comment: "",
                options: {}
            };

            pggPrintProvider.setScope($scope);

            $scope.alerts = [];

            $scope.closeAlert = function (index) {
                $scope.alerts.splice(index, 1);
            };

            var info = pggPrintProvider.getPrintPromise("info.json").then(function (data) {
                if (data.status == 200) {
                    $scope.printInfo = data.data;
                    var scalesAllowed = [];
                    angular.forEach(pggScaleProvider.getScales(), function (scale) {
                        scalesAllowed.push(+scale.scale);
                    });
                    var goodScales = [];
                    for (var i = 0; i < $scope.printInfo.scales.length; i++) {
                        var scale = $scope.printInfo.scales[i];
                        if (scalesAllowed.indexOf(parseInt(+scale.value)) != -1) {
                            goodScales.push(scale);
                        }
                    }
                    $scope.printInfo.scales = goodScales;
                    $scope.printInfo.scales.selected = pggPrintProvider.getPrintScale($scope, pggScaleProvider);
                    $scope.map.on("moveend", function () {
                        $scope.$apply(function () {
                            $scope.printInfo.scales.selected = pggPrintProvider.getPrintScale($scope, pggScaleProvider);
                        });
                    });
                    $scope.printInfo.layouts.selected = $scope.printInfo.layouts[0];
                    $scope.printInfo.dpis.selected = $scope.printInfo.dpis[0];
                    angular.forEach($scope.printInfo.outputFormats, function (of) {
                        if (of.name === "pdf") {
                            $scope.printInfo.outputFormats.selected = of;
                        }
                    });
                    $scope.params.options = $scope.printInfo;
                } else {
                    $log.error("Hiba történt (printInfo)");
                    $log.error(data);
                }
            });

            this.selectScale = function () {
                var resolution = pggScaleProvider.getResolutionForScale($scope.printInfo.scales.selected.value);
                $scope.map.getView().setResolution(resolution);
            };

            $scope.tablak = [];
            $scope.isGazdalkodoiModul = window.location.pathname == "/gazdalkodoi-modul";

            $scope.selectedTables = [];

            this.selectTabla = function (tabla) {
                tabla.selected = !tabla.selected;
                if (tabla.selected) {
                    $scope.selectedTables.push(tabla.properties.id);
                } else {
                    var idx = $scope.selectedTables.indexOf(tabla.properties.id);
                    $scope.selectedTables.splice(idx, 1);
                }
                $scope.selectedTables = $scope.selectedTables.sort();
            };

            this.selectAllTables = function () {
                $scope.selectedTables = [];
                angular.forEach($scope.tablak, function (t) {
                    t.selected = true;
                    $scope.selectedTables.push(t.properties.id);
                });
                $scope.selectedTables = $scope.selectedTables.sort();
            };

            this.deselectAllTables = function () {
                $scope.selectedTables = [];
                angular.forEach($scope.tablak, function (t) {
                    t.selected = false;
                });
            };

            this.doPrint = function () {
                $scope.printInProgress = true;
                var template = pggPrintProvider.createPostTemplate($scope.map, $scope.params);
                var printout = pggPrintProvider.postPrintTerkepPromise(template).then(
                    function (response) {
                        if (response.status == 200 && response.statusText == "OK") {
                            var blob = response.data.response.blob;
                            var filename = response.data.response.fileName || 'natura-terkep.pdf';
                            FileSaver.saveAs(blob, filename);
                            $scope.printInProgress = false;
                        } else {
                            $scope.alerts.push({
                                type: 'danger',
                                msg: 'Sikertelen nyomtatás'
                            });
                            $log.error("Hiba történt (doPrintTerkepTerv)");
                            $log.error(response);
                            $scope.printInProgress = false;
                        }
                    });
            };

            this.doPrintTerv = function () {
                $scope.printTervInProgress = true;
                var selectedTablak = $scope.selectedTables;
                if ($scope.selectedTables.length === 0) {
                    $scope.alerts.push({
                        type: 'danger',
                        msg: 'Nem jelölt ki gazdálkodói táblákat.'
                    });
                    $scope.printTervInProgress = false;
                } else {
                    var printout = pggPrintProvider.postPrintTervPromise($scope.selectedTables).then(
                        function (response) {
                            if (response.status == 200 && response.statusText == "OK") {
                                var blob = response.data.response.blob;
                                var filename = response.data.response.fileName || 'gazdalkodoi-terv.pdf';
                                FileSaver.saveAs(blob, filename);
                                $scope.printTervInProgress = false;
                            } else {
                                $scope.alerts.push({
                                    type: 'danger',
                                    msg: 'Sikertelen nyomtatás'
                                });
                                $log.error("Hiba történt (doPrintTerv)");
                                $log.error(response);
                                $scope.printTervInProgress = false;
                            }
                        });
                }
            };

            this.doPrintJelmagyarazat = function () {
                pggPrintProvider.postPrintJelmagyarazatPromise().then(function (response) {
                    if (response.status == 200 && response.statusText == "OK") {
                        var blob = response.data.response.blob;
                        var filename = response.data.response.fileName || 'natura-terkep-jelmagyarazat.pdf';
                        FileSaver.saveAs(blob, filename);
                    } else {
                        $scope.alerts.push({
                            type: 'danger',
                            msg: 'Sikertelen nyomtatás'
                        });
                        $log.error("Hiba történt (doPrintJelmagyarazat)");
                        $log.error(response);
                    }
                });
            };

        }
    ]);
